import React from "react"
import { arrayOf, shape, number, string } from "prop-types"
import { Map, TileLayer, Marker, Popup } from "react-leaflet"
import "./map.css"

const LeafletMap = ({ locations = [], zoom }) => {
  if (!locations || !locations.length > 0) return null
  const center = locations[0].position

  return (
    <Map center={center} zoom={zoom}>
      <TileLayer
        url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      />

      {locations.map(({ title, position }) => (
        <Marker position={position}>{title && <Popup>{title}</Popup>}</Marker>
      ))}
    </Map>
  )
}

LeafletMap.propTypes = {
  locations: arrayOf(shape({ title: string, position: arrayOf(number) })),
  zoom: number,
}

LeafletMap.defaultProps = {
  locations: [{}],
  zoom: 12,
}

export default LeafletMap
